import { render, staticRenderFns } from "./IndexConfig.vue?vue&type=template&id=e3560bf4&scoped=true"
import script from "./IndexConfig.vue?vue&type=script&lang=js"
export * from "./IndexConfig.vue?vue&type=script&lang=js"
import style1 from "./IndexConfig.vue?vue&type=style&index=1&id=e3560bf4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3560bf4",
  null
  
)

export default component.exports